import { PlayerEvaluationSchema } from '../types/Evaluation';
import { MOCK_PLAYER_EVALUATION } from './evaluation-mock-data';

/**
 * Fetches the player evaluation schema from the API.
 * Currently returns mock data — replace with actual API call.
 */
export async function fetchPlayerEvaluation(playerId: number): Promise<PlayerEvaluationSchema> {
  // TODO: Replace with actual API call
  // return gql(`playerEvaluation(playerId: ${playerId}) { ... }`);
  return new Promise((resolve) => {
    setTimeout(() => resolve(MOCK_PLAYER_EVALUATION), 300);
  });
}

/**
 * Saves the updated player evaluation data.
 * Currently logs to console — replace with actual API call.
 */
export async function savePlayerProfile(data: PlayerEvaluationSchema): Promise<{ success: boolean }> {
  // TODO: Replace with actual API call
  // return gql(`mutation { updatePlayerEvaluation(data: ${serializeGQLObject(data)}) { success } }`);
  console.log('Saving player evaluation:', JSON.stringify(data, null, 2));
  return new Promise((resolve) => {
    setTimeout(() => resolve({ success: true }), 500);
  });
}
